import React, { Fragment } from 'react';
import SeccionCaracteristicas from './../../components/seccion_caracteristicas';
import SeccionFunciona from './../../components/seccion_funciona';
import SeccionConoce from './../../components/seccion_conoce';
import SeccionConsigues from './../../components/seccion_consigues';
import SeccionFooterVertical from './../../components/seccion_footer_vertical';
import SeccionHeader from './../../components/seccion_header';
import SeccionBanner from './../../components/seccion_banner';

import './landing_fvg.scss';

const LandingFVG = () => {

    return ( 
        <Fragment>
            <SeccionHeader />
            <SeccionBanner />
            <SeccionConsigues />
            <SeccionCaracteristicas />
            <SeccionFunciona />
            <SeccionConoce />
            <SeccionFooterVertical />
        </Fragment>
    );
}
 
export default LandingFVG;